import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Dialog from '../../../../../molecules/Dialog';
import ModalContent from '../../common/ModalContent';
import { getWindowInnerHeight } from '../../../../../../games/utils/gamePageUtilities';
import EventLayout from '../../../EventLayout';
import {
  GRAND_PRIZE_URL,
  EVENT_WINNER_URL,
  EVENT_HOW_TO_PARTICIPATE_CONTENT
} from '../../../Constants';
import {
  getTopShopperGrandPriceBannerHyperlink,
  getTopShopperGrandPriceBannerImagePath,
  getTopShopperTermsHyperlink,
  getTopShopperShopMoreHyperlink,
  getEventHowToParticipateContentList
} from '../../../../../selectors/featureFlagsSelector';

const {
  modalHeader: htpHeader = '',
  list: htpList = [],
  linkText: htpLinkText = '',
  href: htpLinkHref = ''
} = EVENT_HOW_TO_PARTICIPATE_CONTENT || {};

interface EventLayoutPageProps {
  platform: 'website' | 'msite' | 'app';
  eventName: string;
  grandEvent: string;
  grandPriceBannerHyperlink: string;
  grandPriceBannerImagePath: string;
  topShopperTermsHyperlink: string;
  shopMoreHyperlink: string;
  ctaInterceptor: () => void;
  pushGaEvent: () => void;
  redirectPage: () => void;
  eventHowToParticipateContentList: string[];
}

const mapStateToProps = (state: any): Record<string, unknown> => {
  return {
    grandPriceBannerHyperlink: getTopShopperGrandPriceBannerHyperlink(state),
    grandPriceBannerImagePath: getTopShopperGrandPriceBannerImagePath(state),
    topShopperTermsHyperlink: getTopShopperTermsHyperlink(state),
    shopMoreHyperlink: getTopShopperShopMoreHyperlink(state),
    eventHowToParticipateContentList: getEventHowToParticipateContentList(state)
  };
};

const connector = connect(mapStateToProps);

const EventLayoutPage = (props: EventLayoutPageProps): JSX.Element => {
  const {
    platform,
    eventName,
    grandEvent,
    ctaInterceptor,
    pushGaEvent,
    redirectPage,
    isAppsFlag,
    grandPriceBannerHyperlink,
    grandPriceBannerImagePath,
    topShopperTermsHyperlink,
    shopMoreHyperlink,
    eventHowToParticipateContentList
  } = props;
  const [componentHeight, setComponentHeight] = useState('100vh');
  const [dialogStatus, setDialogStatus] = useState(false);

  useEffect(() => {
    setComponentHeight(getWindowInnerHeight(window));
  }, []);

  const onTimerComplete = (): void => {
    console.log('Timer Completed!...');
  };

  const showDialog = (): void => {
    setDialogStatus(true);
  };

  const hideDialog = (): void => {
    setDialogStatus(false);
  };

  const onClickHowToParticipate = (): void => {
    showDialog();
  };

  let styleObject = {};
  if (platform !== 'website') {
    styleObject = { height: componentHeight };
  }

  return (
    <div className="tpsps-layout" style={styleObject}>
      <EventLayout
        platform={platform}
        ctaInterceptor={ctaInterceptor}
        pushGaEvent={pushGaEvent}
        eventName={eventName}
        grandEvent={grandEvent}
        onTimerComplete={onTimerComplete}
        redirectPage={redirectPage}
        showDialog={showDialog}
        onClickHowToParticipate={onClickHowToParticipate}
        grandPriceBannerImagePath={grandPriceBannerImagePath}
        grandPriceBannerHyperlink={grandPriceBannerHyperlink}
        shopMoreHyperlink={shopMoreHyperlink}
      />
      <Dialog
        type="modal"
        showDialog={dialogStatus}
        fullWidth={platform !== 'website'}
        onCancel={hideDialog}
      >
        <ModalContent
          platform={platform}
          modalHeader={htpHeader}
          list={eventHowToParticipateContentList}
          linkText={htpLinkText}
          href={topShopperTermsHyperlink || htpLinkHref}
          closeModal={hideDialog}
          isAppsFlag={isAppsFlag}
        />
      </Dialog>
    </div>
  );
};

export default connector(EventLayoutPage);
